import { useEffect, useRef, useState } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export const CountDownTimer = ({ duration, startTimer, onTimerEnd }) => {
    const [time, setTime] = useState(duration);
    const timerRef = useRef(duration);

    useEffect(() => {
        if (startTimer) {
            const timerId = setInterval(() => {
                timerRef.current -= 1;
                if (timerRef.current < 0) {
                    clearInterval(timerId);
                    onTimerEnd();
                } else {
                    setTime(timerRef.current);
                }
            }, 1000);
            return () => clearInterval(timerId);
        }
    }, [startTimer, onTimerEnd]);

    return <Text type='secondary'>{`${time}s`}</Text>;
};
